import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { Navigate } from 'react-router-dom'
import { CardActions, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import InputField from 'components/form/InputField'
import SubmitButton from 'components/form/SubmitButton'
import OverlayLoader from 'components/ui/OverlayLoader'
import { SITE_ADMIN_ROOT, SITE_USER_ROOT } from 'config'
import { selectAuth } from 'store/authentication/slice'
import { forgotPassword } from 'store/authentication/thunks'
import { getEntryPath } from 'store/authentication/utils'

export default function ForgotPassword(): JSX.Element {
  const intl = useIntl()
  const auth = useSelector(selectAuth)
  const { register, handleSubmit, reset } = useForm<ForgotPasswordPayload>()
  const dispatch = useDispatch()

  const { loggedIn, status, checkingLoginStatus, user } = auth

  useEffect(() => {
    if (status === 'succeeded') {
      reset()
    }
  }, [status, reset])

  if (loggedIn) {
    return user.isAdmin ? (
      <Navigate to={getEntryPath() || SITE_ADMIN_ROOT} />
    ) : (
      <Navigate to={getEntryPath() || SITE_USER_ROOT} />
    )
  }

  const submitForm = (data: ForgotPasswordPayload) => {
    const payload = {
      ...data,
      successMessage: intl.formatMessage({ id: 'messages.forgotPasswordSuccess' }),
    }
    dispatch(forgotPassword(payload))
  }

  return (
    <>
      <OverlayLoader visible={checkingLoginStatus} />

      <form onSubmit={handleSubmit(submitForm)}>
        <Typography variant={'h2'}>
          <FormattedMessage id="strings.forgotPassword" />
        </Typography>

        <InputField
          name="email"
          type="email"
          register={register}
          label={<FormattedMessage id="strings.email" />}
          required
        />

        <CardActions>
          <SubmitButton status={status} text={<FormattedMessage id={'strings.resetPassword'} />} />
        </CardActions>
      </form>
    </>
  )
}
